const GITHUB_RAW_URL = "https://raw.githubusercontent.com/ACL4SSR/ACL4SSR/master/Clash/config/";

// 同步Gitee-RawUrl
const GITEE_RAW_URL = "https://gitee.com/rthinking/ACL4SSR/raw/master/Clash/config/";


/**
 * ACL4SSR 默认配置 (GITHUB)
 * @type {*[]}
 */
const ACL4SSR_GITHUB_CONFIGS = [{
    label: "【Github】ACL4SSR_Online(去广告、自动测速、微软分流、苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online.ini`
}, {
    label: "【Github】ACL4SSR_Online_AdblockPlus(去广告、自动测速、微软分流、苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_AdblockPlus.ini`
}, {
    label: "【Github】ACL4SSR_Online_Full(去广告、自动测速、微软分流、苹果分流、增强中国IP段、增强国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_Full.ini`
}, {
    label: "【Github】ACL4SSR_Online_Full_AdblockPlus_[默认]更多去广告版(带AdblockPlus_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_Full_AdblockPlus.ini`
}, {
    label: "【Github】ACL4SSR_Online_Full_Google_谷歌细分(带Google_Play_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_Full_Google.ini`
}, {
    label: "【Github】ACL4SSR_Online_Full_MultiMode_多模式(带游戏、带故障转移、带负载均衡_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_Full_MultiMode.ini`
}, {
    label: "【Github】ACL4SSR_Online_Full_Netflix_奈飞全量(奈飞_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_Full_Netflix.ini`
}, {
    label: "【Github】ACL4SSR_Online_Full_NoAuto(无自动测速_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_Full_NoAuto.ini`
}, {
    label: "【Github】ACL4SSR_Online_Mini_精简版(带去广告、带自动测速、无微软分流、无微软分流、无中国IP增强、无国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_Mini.ini`
}, {
    label: "【Github】ACL4SSR_Online_Mini_AdblockPlus_去广告精简版(去广告、自动测速、无微软分流、无苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_Mini_AdblockPlus.ini`
}, {
    label: "【Github】ACL4SSR_Online_Mini_Fallback_回落精简版(去广告、自动测速、无微软分流、无苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_Mini_Fallback.ini`
}, {
    label: "【Github】ACL4SSR_Online_Mini_MultiCountry_多国分组精简版(去广告、自动测速、无微软分流、无苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_Mini_MultiCountry.ini`
}, {
    label: "【Github】ACL4SSR_Online_Mini_MultiMode_多模式精简版(去广告、自动测速、无微软分流、无苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_Mini_MultiMode.ini`
}, {
    label: "【Github】ACL4SSR_Online_Mini_NoAuto_无自动精简版(去广告、无自动测速、无微软分流、无苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_Mini_NoAuto.ini`
}, {
    label: "【Github】ACL4SSR_Online_MultiCountry_多国分组(去广告、自动测速、微软分流、苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_MultiCountry.ini`
}, {
    label: "【Github】ACL4SSR_Online_NoAuto_无自动测速(去广告、无自动测速、微软分流、苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_NoAuto.ini`
}, {
    label: "【Github】ACL4SSR_Online_NoReject_无广告拦截版(自动测速、微软分流、苹果分流、无中国IP增强、无国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_Online_NoReject.ini`
}, {
    label: "【Github】ACL4SSR_WithChinaIp_带国内IP(去广告、自动测速、微软分流、苹果分流、中国IP增强、无国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_WithChinaIp.ini`
}, {
    label: "【Github】ACL4SSR_WithChinaIp_WithGFW_带国内IP和GFW(去广告、自动测速、微软分流、苹果分流、中国IP增强、国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_WithChinaIp_WithGFW.ini`
}, {
    label: "【Github】ACL4SSR_WithGFW_带GFW(去广告、自动测速、微软分流、苹果分流、无中国IP增强、国外GFW_与Github同步)",
    value: `${GITHUB_RAW_URL}ACL4SSR_WithGFW.ini`
}]

/**
 * ACL4SSR 默认配置 (GITEE)
 * @type {*[]}
 */
const ACL4SSR_GITEE_CONFIGS = [{
    label: "【Gitee】ACL4SSR_Online(去广告、自动测速、微软分流、苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
    value: `${GITEE_RAW_URL}ACL4SSR_Online.ini`
}, {
    label: "【Gitee】ACL4SSR_Online_AdblockPlus(去广告、自动测速、微软分流、苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
    value: `${GITEE_RAW_URL}ACL4SSR_Online_AdblockPlus.ini`
},

    {
        label: "【Gitee】ACL4SSR_Online_Full(去广告、自动测速、微软分流、苹果分流、增强中国IP段、增强国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_Full.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_Full_AdblockPlus_[默认]更多去广告版(带AdblockPlus_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_Full_AdblockPlus.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_Full_Google_谷歌细分(带Google_Play_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_Full_Google.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_Full_MultiMode_多模式(带游戏、带故障转移、带负载均衡_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_Full_MultiMode.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_Full_Netflix_奈飞全量(奈飞_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_Full_Netflix.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_Full_NoAuto(无自动测速_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_Full_NoAuto.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_Mini_精简版(带去广告、带自动测速、无微软分流、无微软分流、无中国IP增强、无国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_Mini.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_Mini_AdblockPlus_去广告精简版(去广告、自动测速、无微软分流、无苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_Mini_AdblockPlus.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_Mini_Fallback_回落精简版(去广告、自动测速、无微软分流、无苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_Mini_Fallback.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_Mini_MultiCountry_多国分组精简版(去广告、自动测速、无微软分流、无苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_Mini_MultiCountry.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_Mini_MultiMode_多模式精简版(去广告、自动测速、无微软分流、无苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_Mini_MultiMode.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_Mini_NoAuto_无自动精简版(去广告、无自动测速、无微软分流、无苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_Mini_NoAuto.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_MultiCountry_多国分组(去广告、自动测速、微软分流、苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_MultiCountry.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_NoAuto_无自动测速(去广告、无自动测速、微软分流、苹果分流、无增强中国IP段、无增强国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_NoAuto.ini`
    }, {
        label: "【Gitee】ACL4SSR_Online_NoReject_无广告拦截版(自动测速、微软分流、苹果分流、无中国IP增强、无国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_Online_NoReject.ini`
    }, {
        label: "【Gitee】ACL4SSR_WithChinaIp_带国内IP(去广告、自动测速、微软分流、苹果分流、中国IP增强、无国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_WithChinaIp.ini`
    }, {
        label: "【Gitee】ACL4SSR_WithChinaIp_WithGFW_带国内IP和GFW(去广告、自动测速、微软分流、苹果分流、中国IP增强、国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_WithChinaIp_WithGFW.ini`
    }, {
        label: "【Gitee】ACL4SSR_WithGFW_带GFW(去广告、自动测速、微软分流、苹果分流、无中国IP增强、国外GFW_与Github同步)",
        value: `${GITEE_RAW_URL}ACL4SSR_WithGFW.ini`
    }
]


const remoteAllConfig = [
    {
        label: "つつの专属规则",
        options: [{
            label: "つつ-全分组",
            value: "https://cdn.jsdelivr.net/gh/lhl77/sub-ini@main/tsutsu-full.ini"
        }, {
            label: "つつ-全分组-地区自动选择",
            value: "https://cdn.jsdelivr.net/gh/lhl77/sub-ini@main/tsutsu-full-urltest.ini"
        }, {
            label: "つつ-超jb精简分组-含国内分流",
            value: "https://cdn.jsdelivr.net/gh/lhl77/sub-ini@main/tsutsu-mini-gfw.ini"
        }]
    },
    {
        label: "【GITEE】ACL4SSR",
        options: ACL4SSR_GITEE_CONFIGS
    },
    {
        label: "【GITHUB】ACL4SSR",
        options: ACL4SSR_GITHUB_CONFIGS
    },
    {
        label: "Special",
        options: [
            {
                label: "NeteaseUnblock(仅规则，No-Urltest)",
                value:
                    "https://cdn.jsdelivr.net/gh/SleepyHeeead/subconverter-config@master/remote-config/special/netease.ini"
            },
            {
                label: "Basic(仅GEOIP CN + Final)",
                value:
                    "https://cdn.jsdelivr.net/gh/SleepyHeeead/subconverter-config@master/remote-config/special/basic.ini"
            }
        ]
    }
]

/**
 * 组合 ACL4SSR 的配置
 * @type {{default: *[], custom: *[]}}
 */
const ACL4SSR_ALL_CONFIGS = {

    // 默认选中的配置
    DEFAULT_ACL4SSR_URL: `${GITEE_RAW_URL}ACL4SSR_Online_Full_AdblockPlus.ini`,
    // 用于配置 ACL4SSR 的默认配置
    GROUP_ACL4SSR_CONFIG: remoteAllConfig,
}

export default ACL4SSR_ALL_CONFIGS
